import { type FC, type ReactNode } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  isShow: boolean;
  brandName: string;
  businessTypeAndOccupation: string;
  totalNumber: number;
  handleCloseModal: () => void;
  children: ReactNode;
};

export const ShopWorksModal: FC<Props> = ({
  isShow,
  brandName,
  businessTypeAndOccupation,
  totalNumber,
  handleCloseModal,
  children,
}) => (
  <div className={styles.background({ isShow })} onClick={handleCloseModal} aria-hidden="true">
    <div className={styles.outer} onClick={(e) => e.stopPropagation()} aria-hidden="true">
      <div className={styles.header}>
        <button type="button" className={styles.iconOuter} onClick={handleCloseModal}>
          <Icon name="cross-thin" />
        </button>
      </div>
      <div className={styles.content}>
        <p className={styles.brandNameAndOccupation}>
          {brandName}｜{businessTypeAndOccupation}
        </p>
        <p className={styles.shopLengthOuter}>
          <span className={styles.shopLength}>{totalNumber}</span> 店舗で募集中
        </p>
        {children}
      </div>
      <div className={styles.bottom} />
    </div>
  </div>
);
